import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MatIconButton, MatTooltip, MatIcon]
})
export class HeaderComponent implements OnInit {
  constructor(private authService: AuthService) {}

  username: string;

  ngOnInit(): void {
    this.username = this.getUsername();
  }

  getUsername(): string {
    if (sessionStorage.currentUser) {
      let user = JSON.parse(sessionStorage.getItem('currentUser'));
      return user.username;
    }
  }

  logout(): void {
    this.authService.logout();
  }
}
